import { useEffect } from 'react'
import smoothscroll from 'smoothscroll-polyfill'

const useSmoothscrollPolyfill = () => {
  useEffect(() => {
    smoothscroll.polyfill()
  }, [])
  return null
}

export default useSmoothscrollPolyfill
